const main = () => {
  console.log("今日も今日とて寒すぎる");
};

document.addEventListener("DOMContentLoaded", () => {
  main();
});
